export interface QuoteBalanceDetailField {
  label: string;
  key: keyof QuoteBalanceRawRow;
}

export interface QuoteBalanceRawRow {
  additional: number;
  anticipation: number;
  cut: number;
  renegotiation: number;
  supplementation: number;
  transference: number;
  transformation: number;
}

export const QUOTE_BALANCE_DETAIL_FIELDS: QuoteBalanceDetailField[] = [
  { label: "Adicional", key: "additional" },
  { label: "Antecipação", key: "anticipation" },
  { label: "Corte", key: "cut" },
  { label: "Repactuação", key: "renegotiation" },
  { label: "Suplementação", key: "supplementation" },
  { label: "Transferência", key: "transference" },
  { label: "Transformação", key: "transformation" },
];
